<template lang="pug">
  .bought-services.gray-bg
    .section
      .container
        .card
          .card-header
            p.card-header-title {{ gettext('Bought services') }}
            .card-head-button(@click="switchArchive") {{ !archive ? gettext('Archive') : gettext('Current') }}
          .card-content
            table.table.is-fullwidth(v-if="(services.items || []).length")
              thead
                tr
                  th #
                  th {{gettext('Name')}}
                  th {{gettext('info')}}
                  th {{gettext('Purchased')}}
                  th {{gettext('Expire')}}
                tr(v-for="item in services.items" :key="item.id")
                  td {{item.id}}
                  td {{getAlias(item.type)}}
                  td(v-if="item.type === CONSTANTS.CV_PROVIDED_SERVICE_NAME") {{interpolate(gettext('%s available (%s used)'), [item.left_hits_number, item.used_hits_number])}}
                  td(v-if="item.type === CONSTANTS.PROVIDED_PAPER_WORK_TYPE_NAME || item.type === CONSTANTS.PROVIDED_PERSONAL_MATCH_TYPE_NAME")
                    div {{gettext('employer`s country')+':' }} {{ item.employer_country.name }}
                    div {{gettext('employee`s country')+':' }} {{ item.jobseeker_country.name }}
                    div {{gettext('status')+':' }} {{ item.management_status.name }}
                  td {{item.since_dt | expire}}
                  td
                    span(v-if="item.till_dt") {{item.till_dt | expire}}
                    span(v-else) ------
            .content.is-fluid(v-else)
              .notification
                .has-text-centered.is-size-4 {{ gettext('You have no bought services!') }}
            vue-paginate(
            v-if="services.total_items"
            :page-count="services.total_pages"
            :page-range="3"
            :initial-page="pageNum-1"
            :clickHandler="toPage"
            )
</template>

<script>
import { gettext, interpolate, ngettext } from '@/services/TranslateHandler'
import { mapGetters, mapActions } from 'vuex'
import VuePaginate from '@/components/paginate'

const CONSTANTS = require('@/constants.json')
const moment = require('moment')
const _ = require('lodash')

export default {
  name: 'BoughtServices',
  data () {
    return {
      CONSTANTS: CONSTANTS,
      pageNum: parseInt(this.$route.query.page) || 1,
      pageSize: 10,
      archive: false,
      services: [],
      aliases: {}
    }
  },
  components: {
    VuePaginate
  },
  methods: {
    gettext: gettext,
    ngettext: ngettext,
    interpolate: interpolate,
    ...mapActions([
      'getBillingProvidedServices'
    ]),
    switchArchive () {
      this.pageNum = 1
      this.archive = !this.archive
      this.getServices()
    },
    getServices () {
      this.getBillingProvidedServices({lang: this.getLanguage, archive: this.archive, account: this.getFinanceAccount, pageNum: this.pageNum, pageSize: this.pageSize}).then(res => {
        this.services = res
      })
    },
    setAliases () {
      this.$set(this.aliases, CONSTANTS.CV_PROVIDED_SERVICE_NAME, gettext('CV contacts service package'))
      this.$set(this.aliases, CONSTANTS.PROVIDED_PAPER_WORK_TYPE_NAME, gettext('Paper work'))
      this.$set(this.aliases, CONSTANTS.PROVIDED_PERSONAL_MATCH_TYPE_NAME, gettext('Personal match'))
    },
    getAlias (alias) {
      let result = alias
      _.each(this.aliases, (item, key) => {
        if (item === alias) result = key
        else if (key === alias) result = item
      })
      return result
    },
    toPage (page) {
      this.pageNum = +page
      this.getServices()
    }
  },
  filters: {
    expire: function (date) {
      return moment(date).format('DD/MM/YYYY, h:mm')
    }
  },
  watch: {
    getLanguage: function () {
      this.setAliases()
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getUser',
      'getFinanceAccount'
    ])
  },
  created () {
    this.getServices()
    this.setAliases()
  }
}
</script>

<style lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/billing/bought-services/index.vue